// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(//fonts.googleapis.com/css?family=Lato);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://rsms.me/inter/inter.css);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root { --vf-Inter : Inter; }
@supports (font-variation-settings: normal) {
  :root { --vf-Inter : Inter var; }
}
:root {
  --color-base025: #f9fafb;
  --color-base050: #f3f5f6;
  --color-base100: #e7eaef;
  --color-base200: #ced6de;
  --color-base300: #acb7c3;
  --color-base400: #95a2b2;
  --color-base500: #67798e;
  --color-base600: #495a6e;
  --color-base700: #394756;
  --color-base800: #29323d;
  --color-base900: #181e25;
  --color-brand050: #ebf0ff;
  --color-brand100: #d8e0fd;
  --color-brand200: #b4c3f8;
  --color-brand300: #7c8ff4;
  --color-brand400: #5a61ed;
  --color-brand500: #261acb;
  --color-brand600: #2a1fc1;
  --color-brand700: #231a9e;
  --color-brand800: #1b147b;
  --color-brand900: #130e58;
  --color-danger050: #ffebed;
  --color-danger100: #fdd8dd;
  --color-danger500: #e9354d;
  --color-danger700: #b8142a;
  --color-danger900: #6e0c19;
  --color-linkHover: #0044cc;
  --color-linkNormal: #0f5dfa;
  --color-linkVisited: #5288f4;
  --color-secondaryBrand050: #ddf8f8;
  --color-secondaryBrand1: rgba( 128, 128, 128, 1.0 );
  --color-secondaryBrand100: #baf2f2;
  --color-secondaryBrand500: #30d8d8;
  --color-secondaryBrand700: #1d9a9a;
  --color-shadowBase: rgba(41, 50, 61, 0.16);
  --color-shadowBrand1: rgba(56, 44, 221, 0.24);
  --color-shadowBrand2: rgba(56, 44, 221, 0.32);
  --color-shadowDanger: rgba(233, 53, 77, 0.24);
  --color-shadowSuccess: rgba(21, 185, 130, 0.24);
  --color-shadowWarning: rgba(246, 122, 40, 0.24);
  --color-success050: #edfdf8;
  --color-success100: #dafbf0;
  --color-success500: #15b982;
  --color-success700: #0e815a;
  --color-success900: #084934;
  --color-tableRollover: var( --color-brand100 );
  --color-tableRolloverSelected: var( --color-secondaryBrand100 );
  --color-tableSelected: var( --color-tertiaryBrandB300 );
  --color-tertiaryBrandA: #15b982;
  --color-tertiaryBrandA300: #ff9f5f;
  --color-tertiaryBrandA500: #f67a28;
  --color-tertiaryBrandB: #ffb647;
  --color-tertiaryBrandB300: #fdcd84;
  --color-tertiaryBrandB500: #ffb647;
  --color-tertiaryBrandC: #f67a28;
  --color-tertiaryBrandC300: #42d3a3;
  --color-tertiaryBrandC500: #15b982;
  --color-tertiaryBrandD: #0f5dfa;
  --color-tertiaryBrandD300: #4f89ff;
  --color-tertiaryBrandD500: #0f5dfa;
  --color-warning050: #ffefd6;
  --color-warning100: #fde7d8;
  --color-warning500: #ffb647;
  --color-warning700: #ef8808;
  --color-warning900: #7a4a00;
  --color-white: #ffffff;
  --color-detailEvenRow: rgba(0, 0, 0, 0.03);
  --size-borderRadiusMedium: 4px;
  --size-borderRadiusSmall: 2px;
  --size-fontBody: 16px;
  --size-fontBodySmall: 15px;
  --size-fontButtonMedium: 15px;
  --size-fontButtonSmall: 12px;
  --size-fontCaption: 13px;
  --size-fontCaptionSmall: 12px;
  --size-fontH1: 20px;
  --size-fontH2: 18px;
  --size-fontH3: 16px;
  --size-large: 16px;
  --size-medium: 8px;
  --size-negative: -4px;
  --size-pad12: 12px;
  --size-padLarge: 16px;
  --size-padMedium: 8px;
  --size-padSmall: 4px;
  --size-padXLarge: 24px;
  --size-padXXLarge: 32px;
  --size-portalMaxWidth: 504px;
  --size-small: 4px;
  --time-fast: 0.1s;
  --time-medium: 0.2s;
  --time-slow: 0.5s;
  --fontFamily-body: var( --vf-Inter );
  --fontFamily-header: var( --vf-Inter );
  --fontFamily-primary: var( --vf-Inter );
  --fontFamily-secondary: var( --vf-Inter );
  --fontFamily-tertiary: var( --vf-Inter );
  --length-margin: 8px;
}`, "",{"version":3,"sources":["webpack://./src/theme/Theme.css"],"names":[],"mappings":"AAEA,QAAQ,kBAAkB,EAAE;AAC5B;EACE,QAAQ,sBAAsB,EAAE;AAClC;AACA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,mDAAmD;EACnD,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,0CAA0C;EAC1C,6CAA6C;EAC7C,6CAA6C;EAC7C,6CAA6C;EAC7C,+CAA+C;EAC/C,+CAA+C;EAC/C,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,8CAA8C;EAC9C,+DAA+D;EAC/D,uDAAuD;EACvD,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,0CAA0C;EAC1C,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,oCAAoC;EACpC,sCAAsC;EACtC,uCAAuC;EACvC,yCAAyC;EACzC,wCAAwC;EACxC,oBAAoB;AACtB","sourcesContent":["@import url('//fonts.googleapis.com/css?family=Lato');\n@import url('https://rsms.me/inter/inter.css');\n:root { --vf-Inter : Inter; }\n@supports (font-variation-settings: normal) {\n  :root { --vf-Inter : Inter var; }\n}\n:root {\n  --color-base025: #f9fafb;\n  --color-base050: #f3f5f6;\n  --color-base100: #e7eaef;\n  --color-base200: #ced6de;\n  --color-base300: #acb7c3;\n  --color-base400: #95a2b2;\n  --color-base500: #67798e;\n  --color-base600: #495a6e;\n  --color-base700: #394756;\n  --color-base800: #29323d;\n  --color-base900: #181e25;\n  --color-brand050: #ebf0ff;\n  --color-brand100: #d8e0fd;\n  --color-brand200: #b4c3f8;\n  --color-brand300: #7c8ff4;\n  --color-brand400: #5a61ed;\n  --color-brand500: #261acb;\n  --color-brand600: #2a1fc1;\n  --color-brand700: #231a9e;\n  --color-brand800: #1b147b;\n  --color-brand900: #130e58;\n  --color-danger050: #ffebed;\n  --color-danger100: #fdd8dd;\n  --color-danger500: #e9354d;\n  --color-danger700: #b8142a;\n  --color-danger900: #6e0c19;\n  --color-linkHover: #0044cc;\n  --color-linkNormal: #0f5dfa;\n  --color-linkVisited: #5288f4;\n  --color-secondaryBrand050: #ddf8f8;\n  --color-secondaryBrand1: rgba( 128, 128, 128, 1.0 );\n  --color-secondaryBrand100: #baf2f2;\n  --color-secondaryBrand500: #30d8d8;\n  --color-secondaryBrand700: #1d9a9a;\n  --color-shadowBase: rgba(41, 50, 61, 0.16);\n  --color-shadowBrand1: rgba(56, 44, 221, 0.24);\n  --color-shadowBrand2: rgba(56, 44, 221, 0.32);\n  --color-shadowDanger: rgba(233, 53, 77, 0.24);\n  --color-shadowSuccess: rgba(21, 185, 130, 0.24);\n  --color-shadowWarning: rgba(246, 122, 40, 0.24);\n  --color-success050: #edfdf8;\n  --color-success100: #dafbf0;\n  --color-success500: #15b982;\n  --color-success700: #0e815a;\n  --color-success900: #084934;\n  --color-tableRollover: var( --color-brand100 );\n  --color-tableRolloverSelected: var( --color-secondaryBrand100 );\n  --color-tableSelected: var( --color-tertiaryBrandB300 );\n  --color-tertiaryBrandA: #15b982;\n  --color-tertiaryBrandA300: #ff9f5f;\n  --color-tertiaryBrandA500: #f67a28;\n  --color-tertiaryBrandB: #ffb647;\n  --color-tertiaryBrandB300: #fdcd84;\n  --color-tertiaryBrandB500: #ffb647;\n  --color-tertiaryBrandC: #f67a28;\n  --color-tertiaryBrandC300: #42d3a3;\n  --color-tertiaryBrandC500: #15b982;\n  --color-tertiaryBrandD: #0f5dfa;\n  --color-tertiaryBrandD300: #4f89ff;\n  --color-tertiaryBrandD500: #0f5dfa;\n  --color-warning050: #ffefd6;\n  --color-warning100: #fde7d8;\n  --color-warning500: #ffb647;\n  --color-warning700: #ef8808;\n  --color-warning900: #7a4a00;\n  --color-white: #ffffff;\n  --color-detailEvenRow: rgba(0, 0, 0, 0.03);\n  --size-borderRadiusMedium: 4px;\n  --size-borderRadiusSmall: 2px;\n  --size-fontBody: 16px;\n  --size-fontBodySmall: 15px;\n  --size-fontButtonMedium: 15px;\n  --size-fontButtonSmall: 12px;\n  --size-fontCaption: 13px;\n  --size-fontCaptionSmall: 12px;\n  --size-fontH1: 20px;\n  --size-fontH2: 18px;\n  --size-fontH3: 16px;\n  --size-large: 16px;\n  --size-medium: 8px;\n  --size-negative: -4px;\n  --size-pad12: 12px;\n  --size-padLarge: 16px;\n  --size-padMedium: 8px;\n  --size-padSmall: 4px;\n  --size-padXLarge: 24px;\n  --size-padXXLarge: 32px;\n  --size-portalMaxWidth: 504px;\n  --size-small: 4px;\n  --time-fast: 0.1s;\n  --time-medium: 0.2s;\n  --time-slow: 0.5s;\n  --fontFamily-body: var( --vf-Inter );\n  --fontFamily-header: var( --vf-Inter );\n  --fontFamily-primary: var( --vf-Inter );\n  --fontFamily-secondary: var( --vf-Inter );\n  --fontFamily-tertiary: var( --vf-Inter );\n  --length-margin: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
